import { ErrorState } from "@common/index";
import { useUserApi } from "@/hooks/apiHooks/useUserApi";

// The failed state of the /users/me read, for everything that waits on
// currentUserAtom: the two route guards (ApprovalGate, AdminRoute) and the
// pages that sit OUTSIDE ApprovalGate (the account subtree and the two walls)
// — without it a failed read left those on a spinner forever. getMeUser drives
// userFetchErrorAtom, so the caller's spinner returns while the retry is in
// flight.
export const AccountLoadError = () => {
    const { getMeUser } = useUserApi();

    return (
        <ErrorState
            message="Couldn't load your account."
            onRetry={() => {
                getMeUser().catch(() => {
                    // The error atom drives the UI.
                });
            }}
        />
    );
};
